<script setup lang="ts">
  import ChevronLeftIcon from '@/shared/assets/icons/ChevronLeftIcon.svg';
  import ChevronRightIcon from '@/shared/assets/icons/ChevronRightIcon.svg';
  import { IconImage } from '@/shared/ui';

  defineProps<{
    currentMonthYear: string;
  }>();

  const emit = defineEmits(['prev-month', 'next-month']);
</script>

<template>
  <div class="flex justify-between items-center p-4 border-b border-gray-02">
    <button
      aria-label="Previous month"
      class="p-2"
      @click="emit('prev-month')"
    >
      <IconImage
        :src="ChevronLeftIcon"
        alt="Previous month"
        class="w-5 h-5"
      />
    </button>
    <h2 class="text-lg font-medium capitalize">
      {{
        currentMonthYear
          .split(' ')
          .filter((_, index) => index !== 1)
          .join(' ')
      }}
    </h2>
    <button
      aria-label="Next month"
      class="p-2"
      @click="emit('next-month')"
    >
      <IconImage
        :src="ChevronRightIcon"
        alt="Next month"
        class="w-5 h-5"
      />
    </button>
  </div>
</template>
